import { createTheme } from "@fluentui/react";
// 2D3D4B
export const darkTheme = createTheme({
  palette: {
    themePrimary: '#21beb4',
    themeLighterAlt: '#f4fcfc',
    themeLighter: '#d4f5f3',
    themeLight: '#b1ece8',
    themeTertiary: '#6dd9d2',
    themeSecondary: '#36c7bd',
    themeDarkAlt: '#1daca3',
    themeDark: '#199189',
    themeDarker: '#126b65',
    neutralLighterAlt: '#111e2a',
    neutralLighter: '#2D3D4B',
    neutralLight: '#101d28',
    neutralQuaternaryAlt: '#0f1b25',
    neutralQuaternary: '#0e1923',
    neutralTertiaryAlt: '#0e1822',
    neutralTertiary: '#c8c8c8',
    neutralSecondary: '#d0d0d0',
    neutralPrimaryAlt: '#dadada',
    neutralPrimary: '#ffffff',
    neutralDark: '#f4f4f4',
    black: '#f8f8f8',
    white: '#111f2b',
  }
});

export const lightTheme = createTheme({
  palette: {
    themePrimary: '#21beb4',
    themeLighterAlt: '#010807',
    themeLighter: '#051f1d',
    themeLight: '#0a3936',
    themeTertiary: '#14736c',
    themeSecondary: '#1da89f',
    themeDarkAlt: '#32c6bc',
    themeDark: '#2D3D4B',
    themeDarker: '#75dbd5',
    neutralLighterAlt: '#f8f8f8',
    neutralLighter: '#f4f4f4',
    neutralLight: '#eaeaea',
    neutralQuaternaryAlt: '#dadada',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#92a6b7',
    neutralSecondary: '#758ca0',
    neutralPrimaryAlt: '#5b7388',
    neutralPrimary: '#111f2b',
    neutralDark: '#30465a',
    black: '#1f3243',
    white: '#ffffff',
  }
});


export const lightFilterTheme = createTheme({
  palette: {
    themePrimary: '#21beb4',
    themeLighterAlt: '#f4fcfc',
    themeLighter: '#d4f5f3',
    themeLight: '#b1ece8',
    themeTertiary: '#6dd9d2',
    themeSecondary: '#1da89f',
    themeDarkAlt: '#1daca3',
    themeDark: '#199189',
    themeDarker: '#126b65',
    neutralLighterAlt: '#111e2a',
    neutralLighter: '#2D3D4B',
    // neutralLight: '#d0d0d0',
    neutralLight: '#199189',
    neutralQuaternaryAlt: '#0f1b25',
    neutralQuaternary: '#0e1923',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#c8c8c8',
    neutralSecondary: '#d0d0d0',
    neutralPrimaryAlt: '#dadada',
    neutralPrimary: '#ffffff',
    neutralDark: '#f4f4f4',
    black: '#f8f8f8',
    white: '#2D3D4B',
  }
});
